// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/771915e7/" + chunkId + "." + __webpack_require__.h() + ".v771915e7.js";
};